import { useTranslation } from 'react-i18next';
import queryClient from '@/Config/api/queryClient';
import { QueryKey } from '@/Config/api/queryKey';
import { ActionDto, AIActionUsageStatsDto } from '@/Domain/api/Action/dto/Action.dto';
import { ActionBox } from '@/Domain/components/Action/ActionBox/ActionBox';
import { RemoveActionModal } from '@/Domain/components/Action/RemoveAction.modal';
import { useActivateRemoteMcp } from '@/Domain/hooks/Action/RemoteMcp/useActivateRemoteMcp';
import { MODAL_NAMES, useModalStore } from '@/Domain/store/modal.store';

type Props = {
  action: ActionDto;
  stats?: AIActionUsageStatsDto;
};

export const RemoteMcpActionBox = ({ action, stats }: Props) => {
  const { t } = useTranslation('remote_mcp');
  const { toggleModal } = useModalStore();

  const handleFetchAction = async () =>
    await queryClient.fetchQuery({
      queryKey: [QueryKey.actions.remoteMcp.get, action.id],
    });

  const { handleActive } = useActivateRemoteMcp(action);

  const handleDelete = () => {
    toggleModal(`${MODAL_NAMES.REMOVE_ACTION_MODAL_NAME}_${action.id}`);
  };

  const handleEdit = async () => {
    const remoteMcpAction = await queryClient.ensureQueryData({
      queryKey: [QueryKey.actions.remoteMcp.get, action.id],
    });
    toggleModal(MODAL_NAMES.REMOTE_MCP_DIALOG, { remoteMcpAction });
  };

  return (
    <>
      <ActionBox
        dataTestId="remote-mcp-action"
        action={action}
        stats={stats}
        onMouseEnterAction={handleFetchAction}
        onActive={handleActive}
        onEdit={handleEdit}
        onDelete={handleDelete}
        buttonLabel={t('button.edit')}
      />

      <RemoveActionModal actionId={action.id} />
    </>
  );
};
